import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { relativeDateTime, localDateTime } from '../../../services/dateService';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

/**
 * Component for displaying dates in relative format with hover effect to show full local date time
 * @param {Object} props - Component props
 * @param {string} props.dateTime - ISO date string
 * @param {string} props.className - Additional CSS classes
 */
const RelativeDateTime = ({ dateTime, className = '' }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const { semantic } = useColors();
  const { replace } = useTextReplacement();
  
  if (!dateTime) return <span className={className}>{replace('N/A')}</span>;
  
  const relative = relativeDateTime(dateTime);
  const local = localDateTime(dateTime);
  
  return (
    <span className="relative inline-block">
      <span 
        className={`${className} ${semantic.formText} cursor-help`}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        aria-label={local}
      >
        {relative}
      </span>
      
      {showTooltip && (
        <span className={`absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-1 ${semantic.contentCardBg} ${semantic.contentCardText} text-xs rounded shadow-lg z-10 whitespace-nowrap`}>
          {local}
          <span className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-900 dark:border-t-gray-700"></span>
        </span>
      )}
    </span>
  );
};

RelativeDateTime.propTypes = {
  dateTime: PropTypes.string,
  className: PropTypes.string
};

export default RelativeDateTime;

